<template>
    <div class="i_page">
        <div v-if="$route.meta.pname" class="i-bread-wrapper" >
            <div style="padding: 0 12px 0 0; margin-right: 12px; border-right: 1px solid lightgray; cursor: pointer;" @click="handleBack"><Icon type="md-arrow-round-back" style="font-size: 18px;margin-right: 6px;"/>返回</div>
            <Breadcrumb class="aFlex">
                <BreadcrumbItem>
                    <span>{{$route.meta.title}}</span>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div class="i-content">
            <keep-alive>
                <!--会被缓存的视图组件-->
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
    </div>
</template>
<style lang="less" scoped>
.i_page{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    /* 面包屑 */
    .i-bread-wrapper{
        position: sticky;
        top: 0;
        padding: 10px 20px;
        z-index: 10;
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 1px 0px 0px #E3E8EE;
        display: flex; align-items: center;
    }
    .i-content{
        flex: 1;
        position: relative;
        background-color: #FFFFFF;
        overflow: hidden;
        overflow-y: auto;
    }
}
</style>
<script>
    export default {
        data () {
            return {

            };
        },
        computed: {

        },
        watch:{

        },
        created(){

        },
        mounted(){

        },
        methods: {
            handleBack(){
                this.$router.go(-1);
            },
        }
    };
</script>
